import { withHost } from 'utils';

export const Api = {
  CreateArtset: () => withHost('/products/sets'),
  FetchArtsets: () => withHost(`/products/sets`),
  UpdateArtset: (id) => withHost(`/products/sets/${id}`),
};
